<template>
  <div class="product-extra-content-block">
    <div class="product-extra-content-block__row">
      <div
        v-for="(content, index) in contents"
        :key="index"
        class="product-extra-content-block__item-container"
        :class="{
          'product-extra-content-block__item-container--just-one': justOneItem,
          [`product-extra-content-block__item--${index + 1}`]: !justOneItem
        }"
      >
        <product-extra-content-item
          :content="content"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import {Vue, Options, Prop} from 'vue-property-decorator';
  import type ProductExtraContent from '../../types/ProductExtraContent';
  import ProductExtraContentItem from '../productExtraContentItem/productExtraContentItem.vue';

  @Options({
    name: 'product-extra-content-block',
    components: {
      ProductExtraContentItem,
    }
  })
  export default class ProductExtraContentBlock extends Vue {
    @Prop()
    contents: Array<ProductExtraContent>;

    get justOneItem(): boolean {
      return this.contents.length === 1;
    }
  }
</script>
